"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("./colors");
const common_1 = require("./common");
const logo_white_png_1 = __importDefault(require("../../static/logo_white.png"));
const verse = {
    logo: logo_white_png_1.default,
    palette: {
        text: {
            default: colors_1.colors.white,
            secondary: colors_1.colors.verseBlue,
        },
        background: {
            default: colors_1.colors.black,
            secondary: colors_1.colors.verseNavyBlue,
            tertiary: colors_1.colors.verseAlmostBlack,
            card: colors_1.colors.verseBlack,
        },
        border: {
            default: colors_1.colors.verseMidGray,
            secondary: colors_1.colors.verseGray,
        },
        input: {
            text: {
                default: colors_1.colors.verseGray,
                hover: colors_1.colors.verseGray,
                active: colors_1.colors.verseGray,
                disabled: colors_1.colors.verseGray,
            },
            background: {
                default: colors_1.colors.verseGrayBlue,
                hover: colors_1.colors.verseGrayBlue,
                active: colors_1.colors.verseGrayBlue,
                disabled: colors_1.colors.verseGrayBlue,
            },
            border: {
                default: colors_1.colors.verseMidGray,
                hover: colors_1.colors.verseMidGray,
                active: colors_1.colors.verseGray,
                disabled: colors_1.colors.verseMidGray,
            },
        },
    },
    border: common_1.border,
    spacing: common_1.spacing,
    shadows: common_1.shadows,
};
exports.default = verse;
//# sourceMappingURL=verse.js.map